import { Component, OnInit } from '@angular/core';
import { BpgEventsService } from '../bpg-events.service';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { Router } from '@angular/router';
import { DataService } from "../../bpg-common/services/data.services";
import { DatePipe } from '@angular/common';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import {FormControl} from '@angular/forms';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-events-list-view',
  templateUrl: './events-list-view.component.html',
  styleUrls: ['./events-list-view.component.css']
})
export class EventsListViewComponent implements OnInit {
 
  p:number;
  showingEvents : number;
  landingData : any;
  selectedMonthYear : any;
  siteData: any;
  siteList : any;
  userAndRoleIdDTO : any;
  selectedBpgsData : any;
  loginData : any;
  //userSiteId: any;
  bpgList : any;
  selectedSiteId : any = Number(localStorage.getItem('userSiteId'));
  siteNamePrint: any;
  bpgNamePrint: any;
  defaultSiteName : any;
  eventList = [];
  noDataFound : boolean;
  selectedErgId:any;
  searchKey : any;
  date :any;
  firstDay : any;
  lastDay : any;
  fromDate : any;
  toDate : any;
  prevMonth:any;
  nextMonth:any;
  dateForGetPrevMonth:any;
  dateForGetNextMonth:any;
  showPaginator = false;
  showErrorMsgs = false;
  eventListArray = [];
  splitedBpgName:any;
  splitedSiteName:any;
  siteAndPath : any;
  siteBpgAndPath: any;
  selectedSite:any;
  selectedBpg:any;
  eventData:any;
  siteIdNo : any;
  sessionData : any;
  iconKeyList:any;
  numberOfElements: number;
  currentPage = 0;
  limit: number = ConstantValues.pageLimit;
  totalPages = 0;
  currentShowingElements: number = ConstantValues.pageLimit;
  //selectedSiteName : any;
  courses= new FormControl();
  deviceInfo = null;
  loginDetails: any  = JSON.parse(localStorage.getItem("loginData"));
  isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  selectAllConstant = "Select All";
  printEventsList = [];
  searchedEventListView:any;
  /**
   * @class EventsListViewComponent
   * @constructor
   */
  constructor(private readonly  bpgEventsService : BpgEventsService,
    private readonly datePipe: DatePipe, private readonly  bpgCommonService: BpgCommonService, 
    private readonly router : Router, private readonly data: DataService,
    private readonly spinner: Ng4LoadingSpinnerService, 
    private readonly environment : EnvironmentConfiguration
    ) { }

  ngOnInit() {

    if(this.isIEOrEdge){
      this.deviceInfo = 'IE';
    } else {
      this.deviceInfo = 'Chrome';
    }
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
    }
    }
    
    this.searchKey = '';
    this.date = new Date();
   
    this.dateForGetPrevMonth = new Date();
    this.dateForGetNextMonth = new Date();
  
    //navigate from site home and chapter home page default set site name and id
    this.data.siteIdAndPath.subscribe(siteIdAndPath => this.siteAndPath = siteIdAndPath);
		if(this.siteAndPath.path === 'siteHome'){
      this.selectedSiteId= (this.siteAndPath.siteId)?this.siteAndPath.siteId : this.selectedSiteId;
      this.selectedErgId = null;
      this.selectedBpg = '--Select ERG--';
    }
    else if(this.siteAndPath.path === 'chapterHome'){
      this.selectedSiteId= (this.siteAndPath.siteId)?this.siteAndPath.siteId : this.selectedSiteId; 
      this.selectedErgId = (this.siteAndPath.bpgId)?this.siteAndPath.bpgId : null;
    }
    else if(this.siteAndPath.path === 'naacHome'){
      this.selectedSiteId= this.siteAndPath.siteId;
      this.selectedErgId = this.siteAndPath.naacAffinityId;
    }
    else if(this.siteAndPath.path === 'eventViewDetails'){
    if(this.deviceInfo === 'IE'){
     this.date = this.datePipe.transform(this.siteAndPath.eventCreateDate, 'yyyy-MM-dd'); 
     this.date = new Date(this.date);
    }else{
     this.date = new Date(this.siteAndPath.eventCreateDate + 'T00:00:00');
    }
      this.siteAndPath.path = null;
      this.selectedSiteId= (this.siteAndPath.siteId)?this.siteAndPath.siteId : 0;
      this.selectedErgId = (this.siteAndPath.bpgId)?this.siteAndPath.bpgId : 0;
      this.selectedBpg = this.siteAndPath.bpgName;
      this.selectedSite = this.siteAndPath.siteName;

      
      if(this.selectedErgId === null || this.selectedBpg === this.selectAllConstant || this.selectedErgId==0){
            this.selectedBpg = this.selectAllConstant;
          }
          else{
            this.selectedBpg = '--Select ERG--';
          }  

      if(this.selectedSiteId === null || this.selectedSite === this.selectAllConstant || this.selectedSiteId == 0){
          this.selectedSite = this.selectAllConstant;
           }
       else{
          this.selectedSite = '--Select Site--';
            }
      this.searchKey = (this.siteAndPath.searchKey)?this.siteAndPath.searchKey :'';
      this.dateForGetPrevMonth = new Date(this.date);
      this.dateForGetNextMonth = new Date(this.date);
    }
    this.prevMonth  = new Date(this.dateForGetPrevMonth.setMonth(this.dateForGetPrevMonth.getMonth() - 1));
    this.nextMonth  = new Date(this.dateForGetNextMonth.getFullYear(), this.dateForGetNextMonth.getMonth()+1, 1);
    
    
    this.loginData = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';
    // newly added
    this.spinner.show();
    this.getSiteDetailsOnLoad();    
  }

  getSiteDetailsOnLoad(){
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT'); 
      this.siteList.unshift({ siteId: 0, siteName: this.selectAllConstant });
      if (this.siteList != null) {
        // for defualt site change siteId
        if (this.selectedSiteId !== 22) {
          const selectedSite = this.siteList.find(s => s.siteId === this.selectedSiteId);
          if (selectedSite) {
              this.selectedSite = selectedSite.siteName;
          } else {
              // Handle case where selectedSiteId is not found
              this.selectedSiteId = this.siteList[1].siteId;
              this.selectedSite = this.siteList[1].siteName;
          }
      } else {
          this.selectedSiteId = this.siteList[1].siteId;
          this.selectedSite = this.siteList[1].siteName;
      }
      } 
      this.getBpgDetailsOnLoad();
    });
  }

  getBpgDetailsOnLoad(){    
    this.selectedBpgsData =
    {
      "filter": {
        "siteId": this.selectedSiteId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
  this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
    this.bpgList = data;
    this.bpgList.unshift({bpgId: 0, bpgName: this.selectAllConstant});
    if (this.bpgList != null) {
      const selectedBpg = this.bpgList.find(b1 => b1.bpgId === this.selectedErgId);
      if (selectedBpg) {
          this.selectedBpg = selectedBpg.bpgName;
      }
    }
    this.getAllOtherDetailsOnLoad();
  });
  }

  getAllOtherDetailsOnLoad(){
    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
    this.fromDate = this.datePipe.transform(this.firstDay, ConstantValues.dateFormats.dateFormat);
    this.toDate = this.datePipe.transform(this.lastDay, ConstantValues.dateFormats.dateFormat);
   
    this.landingData = 
      {
        "filter": {
        "siteId": this.selectedSiteId,
        "bpgId":(this.selectedErgId)? this.selectedErgId : null,
        "fromDate" : this.fromDate,
        "toDate" : this.toDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": this.searchKey,
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
      // storge for retrival
      this.searchedEventListView = this.landingData;
      if ((sessionStorage.getItem("searchEventListView")!==null && sessionStorage.getItem("searchEventListView")!==undefined)){
        this.landingData = JSON.parse(sessionStorage.getItem("searchEventListView"));
          sessionStorage.removeItem("searchEventListView");
          sessionStorage.removeItem("eventDetails");
      }
      this.getAllEvents();
  }

 /** For paginator 
   * @class EventsListViewComponent
   * @method pageChanged
   */
  pageChanged(event){
    this.landingData.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) > this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getAllEvents();
  }
  /** For datepicker date change 
   * @class EventsListViewComponent
   * @method onChange
   */
  onDateChange(event){
    this.selectedMonthYear =  event;
    this.dateForGetNextMonth = event;
    this.dateForGetPrevMonth = event;
    this.firstDay = new Date(this.selectedMonthYear.getFullYear(), this.selectedMonthYear.getMonth(), 1);
    this.lastDay = new Date(this.selectedMonthYear.getFullYear(), this.selectedMonthYear.getMonth() + 1, 0);
    this.fromDate = this.datePipe.transform(this.firstDay, ConstantValues.dateFormats.dateFormat);
    this.toDate = this.datePipe.transform(this.lastDay, ConstantValues.dateFormats.dateFormat);
    
    this.nextMonth  = new Date(this.dateForGetNextMonth.getFullYear(), this.dateForGetNextMonth.getMonth()+1, 1);
    this.prevMonth  = new Date(this.dateForGetPrevMonth.setMonth(this.dateForGetPrevMonth.getMonth() - 1));
    this.date=new Date(this.dateForGetPrevMonth.setMonth(this.dateForGetPrevMonth.getMonth() +1 ));
    
  }
  /** For site change from site list 
   * @class EventsListViewComponent
   * @method siteChange
   * @returns Promise
   */
  siteChange(event) {
    this.selectedErgId = null;
    this.selectedBpg = null;
    this.selectedSiteId = event.siteId;
    this.selectedBpgsData =
      {
        "filter": {
          "siteId": this.selectedSiteId,

        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": "string",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "string",
        "uid": "string"
      }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });


    });

  }
  /** For bpg change from bpg list 
   * @class EventsListViewComponent
   * @method bpgChange
   * @returns Promise
   */
  bpgChange(event){
    
    this.selectedErgId = event.bpgId;
  }
  /** For list event depends on serach key
   * @class EventsListViewComponent
   * @method searchEventList
   * @returns Promise
   */
  

  /** For open Event view deatils component
   * @class EventsListViewComponent
   * @method viewEventDetails
   */
  viewEventDetails(events){
    this.selectedErgId = (this.selectedErgId)?this.selectedErgId : null;
    
    this.searchKey = (this.searchKey)?this.searchKey : '';
    sessionStorage.setItem(this.iconKeyList,"LIST");
    Object.assign(events, {'componentName': 'eventsListView'});
    Object.assign(events,{'selectedSiteId':this.selectedSiteId});
    Object.assign(events,{'selectedErgId':this.selectedErgId});
    if(this.selectedBpg !== null && this.selectedErgId !== undefined){
      Object.assign(events,{'selectedBpgName':this.selectedBpg.bpgName});
    }
    if (this.selectedSite !== undefined) {
      Object.assign(events, { 'selectedSiteName': this.selectedSite.siteName });
    }
    Object.assign(events,{'searchKey':this.searchKey});
   sessionStorage.setItem("eventDetails",JSON.stringify(events));
   sessionStorage.setItem("searchEventListView",JSON.stringify(this.searchedEventListView));
    this.router.navigate(['event-view-details']);
  }
  /** For button search 
   * @class EventsListViewComponent
   * @method searchEvents
   */
  searchEvents(){

    this.selectedSiteId = (this.selectedSiteId) ? this.selectedSiteId : null;
    this.selectedErgId = (this.selectedErgId > 0) ? this.selectedErgId : null;
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    if(this.selectedErgId === null){
    this.landingData = 
      {
        "filter": {
        "siteId": this.selectedSiteId,
        "fromDate" : this.fromDate,
        "toDate" : this.toDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": this.searchKey,
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
    }
    else{
      this.landingData = 
      {
        "filter": {
        "siteId": this.selectedSiteId,
        "bpgId" : this.selectedErgId,
        "fromDate" : this.fromDate,
        "toDate" : this.toDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": this.searchKey,
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
    }
    this.searchedEventListView = this.landingData;
    this.getAllEvents();
  }
  /** For button search 
   * @class EventsListViewComponent
   * @method previousMonthClick
   */
  previousMonthClick(){
    this.date=this.prevMonth;
    this.dateForGetNextMonth = this.date;
    this.dateForGetPrevMonth = this.date;
    this.nextMonth  = new Date(this.dateForGetNextMonth.getFullYear(), this.dateForGetNextMonth.getMonth()+1, 1);
    this.prevMonth  = new Date(this.dateForGetPrevMonth.setMonth(this.dateForGetPrevMonth.getMonth() - 1));
    this.date=new Date(this.dateForGetNextMonth.getFullYear(), this.dateForGetNextMonth.getMonth()+1);

    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
    this.fromDate = this.datePipe.transform(this.firstDay, ConstantValues.dateFormats.dateFormat);
    this.toDate = this.datePipe.transform(this.lastDay, ConstantValues.dateFormats.dateFormat);

    if(this.selectedErgId === 0 || this.selectedErgId === undefined || this.selectedErgId === null){
      
      this.landingData = 
      {
        "filter": {
        "siteId": this.selectedSiteId,
        "fromDate" : this.fromDate,
        "toDate" : this.toDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": this.searchKey,
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
    }
    else{
      
    this.landingData = 
      {
        "filter": {
        "siteId" : this.selectedSiteId,
        "bpgId" : this.selectedErgId,
        "fromDate" : this.fromDate,
        "toDate" : this.toDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": this.searchKey,
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
    }
      this.getAllEvents();
  }
   /** For button search 
   * @class EventsListViewComponent
   * @method nextMonthClick
   */
  nextMonthClick(){
    this.date=this.nextMonth;
    this.dateForGetNextMonth = this.date;
    this.dateForGetPrevMonth = this.date;
    this.nextMonth  = new Date(this.dateForGetNextMonth.getFullYear(), this.dateForGetNextMonth.getMonth()+1, 1);
    this.prevMonth  = new Date(this.dateForGetPrevMonth.setMonth(this.dateForGetPrevMonth.getMonth() - 1));
    this.date=new Date(this.dateForGetNextMonth.getFullYear(), this.dateForGetNextMonth.getMonth()+1);
  

    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
    this.fromDate = this.datePipe.transform(this.firstDay, ConstantValues.dateFormats.dateFormat);
    this.toDate = this.datePipe.transform(this.lastDay, ConstantValues.dateFormats.dateFormat);
   
    if(this.selectedErgId === 0 || this.selectedErgId === undefined || this.selectedErgId === null){
     
      this.landingData = 
      {
        "filter": {
        "siteId": this.selectedSiteId,
        "fromDate" : this.fromDate,
        "toDate" : this.toDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": this.searchKey,
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
    }
    else{
    this.landingData = 
      {
        "filter": {
        "siteId" : this.selectedSiteId,
        "bpgId" : this.selectedErgId,
        "fromDate" : this.fromDate,
        "toDate" : this.toDate
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": this.searchKey,
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
    }
      this.getAllEvents();
  }
     /** For getting all events 
   * @class EventsListViewComponent
   * @method getAllEvents
   * @returns Promise
   */
  getAllEvents(){
    this.bpgEventsService.getAllEvents(this.landingData).subscribe(data=>{
        this.eventList = data.content;
        this.numberOfElements = data.totalElements;
        for(const event of this.eventList){
          const bpgName = event.bpgName;
          this.splitedBpgName = (bpgName.split("("));
          Object.assign(event, {'filteredBpgName': this.splitedBpgName[0]});
          const siteName = event.siteName;
          this.splitedSiteName = (siteName.split("("));
          Object.assign(event, {'filteredSiteName': this.splitedSiteName[0]});
        }
        if (this.eventList.length === 0) {
          this.noDataFound = true;
        } else {
          this.noDataFound = false;
        }
        this.spinner.hide();
    });
    this.searchedEventListView = this.landingData;
    // for downloding in excel get all events
    this. getEventsForDownload();
  }
  onOpenCalendar(container){
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };     
    container.setViewMode('month');
  }

  downloadEvents(){
    const filteredData = this.printEventsList.map(({ siteName, bpgName, eventName,
      eventCreateDate,startTime,endTime,description}) => ({ SiteName:siteName, BpgName:bpgName, EventName:eventName,
       EventDate:eventCreateDate,StartTime:startTime,EndTime:endTime,Description:description}));
    this.bpgEventsService.exportAsExcelFile(filteredData, "EventsReport");
  }

  printEvents(){
    const printContents = document.getElementById("printEvents").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  }

  getEventsForDownload(){
    const landingData = 
      {
        filter: this.landingData.filter,
        moduleId: 0,
        page: 0,
        presentRole: "string",
        searchTerm: this.searchKey,
        size: 2000,
        sortDirection: "ASC",
        sortProperty: "event_create_date",
        uid: ""
      }
    this.bpgEventsService.getAllEvents(landingData).subscribe(data=>{
      if(data.content!=null){
        this.printEventsList = data.content;
            // newly added for printing site and bpg name in pdf
      if(this.selectedSiteId==null || this.selectedSiteId==undefined || this.selectedSiteId==0){
        this.siteNamePrint = this.selectAllConstant;
      }else if(typeof(this.selectedSiteId)=='number'){
        if(this.siteList!=null && this.siteList!=undefined){
          this.siteNamePrint  = this.siteList.find(b => b.siteId === this.selectedSiteId).siteName;
        }
      }else{
        this.siteNamePrint = this.selectAllConstant;
      }
      if(this.selectedErgId==null || this.selectedErgId==undefined
        || this.selectedErgId==0){
          this.bpgNamePrint = this.selectAllConstant;
      }else if(typeof(this.selectedErgId)=='number'){
        this.bpgNamePrint  = this.bpgList.find(b => b.bpgId === this.selectedErgId).bpgName;
      }else{
        this.bpgNamePrint = this.selectAllConstant;
      }
      }
      
  });
  }
}
